import { render, staticRenderFns } from "./Charities.vue?vue&type=template&id=9aa6b9b6"
import script from "./Charities.vue?vue&type=script&lang=js"
export * from "./Charities.vue?vue&type=script&lang=js"
import style0 from "./Charities.vue?vue&type=style&index=0&id=9aa6b9b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports